import {
  IRegInvestAmountResponse,
  IRegInvestSavingsResponse,
} from 'aem-libs-regular-investment/src/services/types'

import { IInputAmountValues, IInputSavingsValues } from '../model'
import { CalcType } from '../model/enums'

export const SET_APP_DATA = 'app/SET_APP_DATA'
export const INIT_AMOUNT = 'amount/INIT_AMOUNT'
export const INIT_SAVINGS = 'savings/INIT_SAVINGS'
export const SET_AMOUNT_INPUTS = 'amount/SET_AMOUNT_INPUTS'
export const SET_AMOUNT_RESULT = 'amount/SET_AMOUNT_RESULT'
export const SET_EXTRA_DEPOSIT = 'amount/SET_EXTRA_DEPOSIT'
export const SET_SAVINGS_INPUTS = 'savings/SET_SAVINGS_INPUTS'
export const SET_SAVINGS_RESULT = 'savings/SET_SAVINGS_RESULT'
export const SET_CALC_TAB = 'app/SET_CALC_TAB'

interface IInitAmountAction {
  type: typeof INIT_AMOUNT
  inputs: IInputAmountValues
  result: IRegInvestAmountResponse
}

interface IInitSavingsAction {
  type: typeof INIT_SAVINGS
  inputs: IInputSavingsValues
  result: IRegInvestSavingsResponse
}

interface ISetAppDataAction {
  type: typeof SET_APP_DATA
  calcType: CalcType
}

interface ISetCalcTabAction {
  type: typeof SET_CALC_TAB
  calcType: CalcType
}

interface ISeAmountInputsAction {
  type: typeof SET_AMOUNT_INPUTS
  inputs: IInputAmountValues
}

interface ISetAmountResultAction {
  type: typeof SET_AMOUNT_RESULT
  result: IRegInvestAmountResponse
}

interface ISetSavingsInputs {
  type: typeof SET_SAVINGS_INPUTS
  inputs: IInputSavingsValues
}

interface ISetSavingsResultAction {
  type: typeof SET_SAVINGS_RESULT
  result: IRegInvestSavingsResponse
}

interface ISetExtraDepositAction {
  type: typeof SET_EXTRA_DEPOSIT
  hasExtraDeposit: boolean
}

export type AppActions = ISetAppDataAction | ISetCalcTabAction

export type AmountActions =
  | ISeAmountInputsAction
  | ISetAmountResultAction
  | ISetExtraDepositAction
  | IInitAmountAction

export type SavingsActions =
  | ISetSavingsInputs
  | ISetSavingsResultAction
  | IInitSavingsAction
